import { useEffect, useState } from "react";
import { Card, Table, Input, Button, Steps, Row, Col, Affix, DatePicker, Select, message, Spin, Tabs, Typography, Alert, InputNumber, Modal, Form, Space } from "antd";
import { ResponsivePie } from '@nivo/pie';
import { BASE_URL, DateFormat } from '../Components/Constant';
import ApiService from "./apiService";
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { useNavigate, useLocation } from 'react-router-dom';
import SummaryTab from "./SummaryBatchLifeCycle";
import ProcessingBatch from "./ProcessingBatch";
import { formatProdErrorMessage } from "@reduxjs/toolkit";
import PackageBatch from "./PackageBatch";
import { use } from "react";


const { Option } = Select;
const { TabPane } = Tabs;
const { Title } = Typography;

const EnhancedCreateRecord = () => {
  const [form] = Form.useForm();
  const { objectName, id } = useParams();
  const [loading, setLoading] = useState(true);
  const [recordData, setRecordData] = useState([]);
  const [disableEdit, setDisableEdit] = useState(false);
  const [relatedFields, setRelatedFields] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [batchLineItem, setBatchLineItem] = useState([]);
  const [recordId, setRecordId] = useState(null);
  const navigate = useNavigate();
  const [savedRecord, setSavedRecord] = useState(false);
  const location = useLocation();
  const SelectedRecord = location?.state?.record;
  const [activeTab, setActiveTab] = useState("Batch Details");
  const [pieData, setpieData] = useState([]);
  const [totalAdded, setTotalAdded] = useState();
  const [allFinishedProducts, setAllFinishedProducts] = useState([]);
  const [selectedFinishedProductForProcess, setSelectedFinishedProductForProcess] = useState([]);
  const [bagWeight, setBagWeight] = useState();
  const [allBagProducts, setAllBagProducts] = useState([]);
  const [selectedBagProductForProcess, setSelectedBagProductForProcess] = useState([]);
  const [ExpectedPackagingQuantity, setExpectedPackagingQuantity] = useState();
  const [mixedData, setMixedData] = useState([]);
  const [BatchStartDateTime, setBatchStartDateTime] = useState();
  const [BatchRatioConfiguration, setBatchRatioConfiguration] = useState();
  const [BatchNotes, setBatchNotes] = useState();
  const [BatchTotalInputQuantity, setBatchTotalInputQuantity] = useState();
  const [batchName, setBatchName] = useState();
  const [alertMessage, setAlertMessage] = useState("");
  const [templateModal, setTemplateModal] = useState(false);
  const [saveTemplateModal, setSaveTemplateModal] = useState(false);
  const [templateData, setTemplateData] = useState([]);
  const [allTemplates, setAllTemplate] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedTemplateBeforeSave, setSelectedTemplateBeforeSave] = useState(null);
  const [dataForTemplate, setDataforTemplate] = useState([]);
  const [inputStatusError, setInputStatusError] = useState(false);
  const [isStock, setIsStock] = useState(false);
  const [BatchInputLineItemAfterSave, setBatchInputLineAfterSave] = useState(null);


  useEffect(() => {
    fetchBatch();
  }, [id]);

  const fetchBatch = async () => {
    setLoading(true);
    try {
      const Batch = new ApiService(
        `${BASE_URL}/fetch_single_record/Batch/${id}`,
        { "Content-Type": "application/json" },
        "GET"
      );

      const data = await Batch.makeCall();

      setRecordData(data);
      setBatchStartDateTime(data?.BatchDateTime);
      setBatchRatioConfiguration(data?.RatioConfiguration);
      setBatchNotes(data?.Note);
      setBatchTotalInputQuantity(data?.TotalQuantity);
      setBatchName(data?.Name);
      setSelectedBagProductForProcess(data?.SelectedBag?._id);
      setSelectedFinishedProductForProcess(data?.FinishedProduct?._id);
      setBagWeight(data?.BagWeight);
      setExpectedPackagingQuantity(data?.ExpectedPackagingQuantity);


      const batchLineItemsService = new ApiService(`${BASE_URL}/fetch_records_parent_childs/BatchInputLineItem/Batch_id/${data?._id}`, {}, 'GET');
      const batchLineItemsResponse = await batchLineItemsService.makeCall();
      setBatchLineItem(batchLineItemsResponse);
      // setBatchInputLineAfterSave(batchLineItemsResponse);
      setBatchInputLineAfterSave(JSON.parse(JSON.stringify(batchLineItemsResponse)));

      setInventory(prevInventory => prevInventory.map(item => {
        const matchingBatchItem = batchLineItemsResponse.find(batchItem => batchItem.Name === item.Name);
        if (matchingBatchItem) {
          return {
            ...item,
            TotalQuantityMetricTon: matchingBatchItem.TotalQuantityMetricTon || extractNumericQuantity(item.AvailableQuantity)
          };
        }
        return item;
      }));
      setInventory(prevInventory => prevInventory.map(item => {
        const matchingBatchItem = batchLineItemsResponse.find(batchItem => batchItem.Name === item.Name);
        if (matchingBatchItem) {
          return {
            ...item,
            TotalQuantityMetricTon: matchingBatchItem.UnitOfMeasure !== "Metric Tons"
              ? (matchingBatchItem.TotalQuantityMetricTon || extractNumericQuantity(item.AvailableQuantity)) / 1000
              : matchingBatchItem.TotalQuantityMetricTon || extractNumericQuantity(item.AvailableQuantity)
          };
        }
        return item;
      }));
      setSavedRecord(true);
      setDisableEdit(true);

    }
    catch (error) {

    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!BatchStartDateTime && !SelectedRecord?._id) {
      setBatchStartDateTime(dayjs().format("DD/MM/YYYY hh:mm A"));
    }
  }, [BatchStartDateTime]);

  useEffect(() => {
    if (!savedRecord) {
      fetchTemplates();
    }
  }, []);

  const fetchTemplates = async () => {
    try {
      const apiService = new ApiService(`${BASE_URL}/get_all_mixture_template`, {}, 'GET');
      const res = await apiService.makeCall();
      setAllTemplate(res);
    }
    catch (Error) {

    }
  }

  useEffect(() => {
    if (inventory.length === 0 || allFinishedProducts.length === 0 || allBagProducts.length === 0) {
      fetchProducts();
    }
  }, [recordData]);


  const fetchProducts = async () => {
    setLoading(true);
    try {
      const getData = new ApiService(`${BASE_URL}/fetch_records/Product`, {}, 'GET');
      const responseData = await getData.makeCall();
      const finishedProducts = responseData?.records?.filter(data => data.ManufacturingStage === 'Fully-Processed');
      const bagProdcuts = responseData?.records?.filter(data => data.ProductType === 'Packaging');
      const rawMaterials = responseData?.records?.filter(data => data.ProductType === 'Raw Material');
      setInventory(rawMaterials);
      setAllFinishedProducts(finishedProducts);
      setAllBagProducts(bagProdcuts);
    } catch (err) {
      const errorMessage = err && typeof err === 'object'
        ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to create due to unknown error';
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }

  const handleAddMaterial = (value, key) => {
    populateBatchLineItems(value, key);
  };


  const mixedColumns = [
    { title: "Material Name", dataIndex: "Name", key: "Name" },
    { title: "Available Stock", dataIndex: "AvailableQuantity", key: "AvailableQuantity" },
    {
      title: "Unit of measure", dataIndex: "UnitofMeasure", key: "UnitOfMeasure",
      render: (_, record) => {
        return `${record.UnitOfMeasure}`
      }
    },
    {
      title: "Quantity", dataIndex: "TotalQuantityMetricTon",key: "TotalQuantityMetricTon",
      render: (_, record) => {
        if (recordData?.Status === "Created") { 
          const matchingRecord = Array.isArray(BatchInputLineItemAfterSave) 
          ? BatchInputLineItemAfterSave.find(item => item.Name === record.Name) 
          : undefined;
                const additionalQuantity = matchingRecord ? matchingRecord?.Quantity : 0;
          if (record?.TotalQuantityMetricTon > (extractNumericQuantity(record?.AvailableQuantity) + additionalQuantity)) {
            message.error(`Quantity should not exceed available stock for ${record?.Name}`);
            return `${record?.TotalQuantityMetricTon.toFixed(2)} Metric Tons`;
          }
         if (record?.UnitOfMeasure === "Bags" ) {
           
            if(((record?.Quantity) > extractNumericQuantity(record?.AvailableQuantity) + additionalQuantity)){
            message.error(`Quantity should not exceed available stock for ${record?.Name}`);
            return `${((record.TotalQuantityMetricTon) * 1000 / record.BagWeight)}Bags (${record?.TotalQuantityMetricTon.toFixed(2)} Metric Tons)`
            }
          }

        } else {
          if(!recordData?.Status){
          if (record?.TotalQuantityMetricTon > extractNumericQuantity(record?.AvailableQuantity)) {
            message.error(`Quantity should not exceed available stock for ${record?.Name}`);
            return `${record?.TotalQuantityMetricTon.toFixed(2)} Metric Tons`;
          }
          else if (record?.UnitOfMeasure === "Bags" && ((record?.TotalQuantityMetricTon) * 1000 / record.BagWeight) > extractNumericQuantity(record?.AvailableQuantity)) {
            message.error(`Quantity should not exceed available stock for ${record?.Name}`);
            return `${((record.TotalQuantityMetricTon) * 1000 / record.BagWeight)}Bags (${record?.TotalQuantityMetricTon.toFixed(2)} Metric Tons)`
          }
        }
        }
        if (record?.UnitOfMeasure !== "Metric Tons") {
          return `${((record.TotalQuantityMetricTon) * 1000 / record.BagWeight)}Bags (${record?.TotalQuantityMetricTon.toFixed(2)} Metric Tons)`
        }
        return `${record?.TotalQuantityMetricTon.toFixed(2)} Metric Tons`;
      }
    },
    {
      title: "% in Mixture",
      key: "RatioPercentage",
      dataIndex: "RatioPercentage",
      render: (_, record) => {
        return record.RatioPercentage ? `${record.RatioPercentage}%` : "";
      }
    },
    {
      title: "Add to Mixture",
      key: "RatioPercentage",
      dataIndex: "RatioPercentage",
      render: (_, record, index) => {
        return (
          <InputNumber
            max={100}
            value={record.RatioPercentage}
            disabled={savedRecord && recordData?.Status !== "Created"}
            status={inputStatusError ? "error" : ""}
            onChange={(e) => {
              if (e > 100) {
                message.error('Value should be less than 100');
                return;
              } else {
                handleAddMaterial(e, index);

              }
            }
            }
            onWheel={preventScroll}
            style={{ width: "80px" }}
          />
        );
      },
    },

  ]

  useEffect(() => {
    if (inventory.length > 0) {
      setLoading(true);
      setpieData(
        Array.isArray(batchLineItem)
          ? batchLineItem
            .filter(item => item?.TotalQuantityMetricTon > 0)
            .map(item => ({
              id: item?.Name || "", // Handle missing Name
              label: item?.Name || "",
              value: item?.RatioPercentage || 0, // Handle missing RatioPercentage
            }))
          : []
      );
      setTotalAdded(
        Array.isArray(batchLineItem)
          ? batchLineItem.reduce((sum, item) => sum + (item?.TotalQuantityMetricTon || 0), 0)
          : 0
      );
      setLoading(false);
    }
  }, [inventory, batchLineItem])

  const handleSave = async () => {

    let exceedsStock = false;

    mixedData.forEach(record => {
      if (recordData?.Status === "Created") {
        const matchingRecord = Array.isArray(BatchInputLineItemAfterSave) 
        ? BatchInputLineItemAfterSave.find(item => item.Name === record.Name) 
        : undefined;
            const additionalQuantity = matchingRecord ? matchingRecord.Quantity : 0;
        if (record?.UnitOfMeasure === "Bags") {
          if (record?.Quantity > ((extractNumericQuantity(record.AvailableQuantity)) + additionalQuantity)) {
            message.error(`Quantity should not exceed Available Stock for ${record.Name}`);
            exceedsStock = true;
          }
        }
        else {
          if (record?.TotalQuantityMetricTon > (extractNumericQuantity(record.AvailableQuantity) + additionalQuantity)) {
            message.error(`Quantity should not exceed Available Stock for ${record.Name}`);
            exceedsStock = true;
          }
        }
      } else {
        if(!recordData?.Status){
          if (record?.TotalQuantityMetricTon > extractNumericQuantity(record?.AvailableQuantity)) {
            message.error(`Quantity should not exceed available stock for ${record?.Name}`);
            exceedsStock = true;
          }
          else if (record?.UnitOfMeasure === "Bags" && ((record?.TotalQuantityMetricTon) * 1000 / record.BagWeight) > extractNumericQuantity(record?.AvailableQuantity)) {
            message.error(`Quantity should not exceed available stock for ${record?.Name}`);
            exceedsStock = true;
          }
        }
      }
    });

    if (exceedsStock) {
      return;
    }


    const filteredbatchLineItem = batchLineItem?.filter(
      item => !(item?.TotalQuantityMetricTon === 0 && item?.Quantity === 0)
    );



    

    if (!BatchTotalInputQuantity) {
      message.error("Please enter the Batch Total Input Quantity.");
      return;
    }

    if (!BatchStartDateTime) {
      message.error("Please enter the Batch Start Date and Time.");
      return;
    }


    if (!bagWeight) {
      message.error("Please enter the Bag Weight.");
      return;
    }

    const totalRatioPercentage = filteredbatchLineItem.reduce((sum, item) => sum + (item.RatioPercentage || 0), 0);
    if (totalRatioPercentage != 100) {
      setAlertMessage("The total ratio percentage must be exactly 100%.");
      setInputStatusError(true);
      return;
    }

    const totalQuantityForMetricTOne = filteredbatchLineItem.reduce((sum, item) => sum + (item.TotalQuantityMetricTon || 0), 0);
    if (totalQuantityForMetricTOne != BatchTotalInputQuantity) {
      setAlertMessage("The total inventory quantity (in metric tons) must match the total batch quantity.");
      return;
    }

    filteredbatchLineItem.forEach(item => {
      if (item?.TotalQuantityMetricTon != null) {
        item.TotalQuantityMetricTon = parseFloat(item.TotalQuantityMetricTon.toFixed(2));
        item.Quantity = parseFloat(item.Quantity.toFixed(2));

      }
    });


    const updatedBatchLineItems = filteredbatchLineItem.map(({ BagWeight, ...rest }) => ({
      ...rest,
      Batch_id: recordData?._id,
      Status: "Pending"
    }));

    


    if (savedRecord && recordData?.Status === "Created") {
      const body = {
        object_name: objectName,
        data: {
          _id: recordData?._id,
          BatchDateTime: BatchStartDateTime,
          RatioConfiguration: BatchRatioConfiguration,
          Note: BatchNotes,
          TotalQuantity: BatchTotalInputQuantity,
          FinishedProduct_id: selectedFinishedProductForProcess,
          SelectedBag_id: selectedBagProductForProcess,
          BagWeight: bagWeight,
          ExpectedPackagingQuantity: ExpectedPackagingQuantity,
        }
      };

      try {
        setLoading(true);
        const apiService = new ApiService(
          `${BASE_URL}/insert_or_update_records`,
          { 'Content-Type': 'application/json' },
          'POST',
          body
        );

        const response = await apiService.makeCall();
        setSavedRecord(true);
        message.success('Batch updated successfully');
        setRecordId(response?.id);
        const recordId = response?.id;
        if (recordId) {
          const batchId = recordId;
          setRecordId(batchId); // Store batchId in state if needed

          // Step 2: Prepare BatchLineItems with the new Batch_id
          const updatedBatchLineItems = filteredbatchLineItem?.map(({ CreatedBy_id,LastModifiedBy_id,CreatedBy,LastModifiedBy,User,RawMaterial,Batch,BagWeight, ...rest }) => ({
            ...rest,
            Batch_id: batchId,
            Status: "Pending"
          }));

          const bulkRecord = {
            "object_name": "BatchInputLineItem",
            "updates": updatedBatchLineItems
          }
          const apiServiceforCreating = new ApiService(
            `${BASE_URL}/bulk_upsert_records`,
            { 'Content-Type': 'application/json' },
            'POST',
            bulkRecord
          );

          const respons = await apiServiceforCreating.makeCall();
          message.success('Batch line items are updated successfully');
          const getlineitems = new ApiService(`${BASE_URL}/fetch_records_parent_childs/BatchInputLineItem/Batch_id/${recordId}`, {}, 'GET');
          const res = await getlineitems.makeCall();
          setBatchLineItem(res);
          setBatchInputLineAfterSave(res);
          navigate(`/EnhancedCreateRecord/${objectName}/${recordId}`);
          // const getData = new ApiService(`${BASE_URL}/fetch_single_record/${objectName}/${recordId}`, {}, 'GET');
          // const responseData = await getData.makeCall();
          // setRecordData(responseData);
          // setSelectedBagProductForProcess(responseData?.SelectedBag?._id);
          // setSelectedFinishedProductForProcess(responseData?.FinishedProduct?._id);
          // setBagWeight(responseData?.BagWeight);
          // setExpectedPackagingQuantity(responseData?.ExpectedPackagingQuantity);
          // setBatchStartDateTime(responseData?.BatchDateTime);
          // setBatchRatioConfiguration(responseData?.RatioConfiguration);
          // setBatchNotes(responseData?.Note);
          // setBatchTotalInputQuantity(responseData?.TotalQuantity);
          // setBatchName(responseData?.Name);
          setDisableEdit(true);

        }
      }
      catch (err) {
        const errorMessage = err && typeof err === 'object'
          ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
          : 'Failed to create due to unknown error';
        message.error(errorMessage);

      }
      finally {
        setLoading(false);
      }

    } 
    else {
      const body = {
        object_name: objectName,
        data: {
          BatchDateTime: BatchStartDateTime,
          RatioConfiguration: BatchRatioConfiguration,
          Note: BatchNotes,
          TotalQuantity: BatchTotalInputQuantity,
          FinishedProduct_id: selectedFinishedProductForProcess,
          SelectedBag_id: selectedBagProductForProcess,
          BagWeight: bagWeight,
          ExpectedPackagingQuantity: ExpectedPackagingQuantity,
          Status: "Created",
          ApprovalStatus: "Not Submitted"

        }
      };


      try {
        setLoading(true);
        const apiService = new ApiService(
          `${BASE_URL}/insert_or_update_records`,
          { 'Content-Type': 'application/json' },
          'POST',
          body
        );

        const response = await apiService.makeCall();
        setSavedRecord(true);
        message.success('Batch is created successfully');
        setRecordId(response?.id);
        const recordId = response?.id;
        if (recordId) {
          const batchId = recordId;
          setRecordId(batchId); // Store batchId in state if needed

          // Step 2: Prepare BatchLineItems with the new Batch_id
          const updatedBatchLineItems = filteredbatchLineItem.map(({ BagWeight, ...rest }) => ({
            ...rest,
            Batch_id: batchId,
            Status: "Pending"

          }));

          const bulkRecord = {
            object_name: "BatchInputLineItem",
            records: updatedBatchLineItems
          }
          const apiServiceforCreating = new ApiService(
            `${BASE_URL}/add_bulk_records`,
            { 'Content-Type': 'application/json' },
            'POST',
            bulkRecord
          );
          const respons = await apiServiceforCreating.makeCall();
          message.success('Batch line items are created successfully');
          const getlineitems = new ApiService(`${BASE_URL}/fetch_records_parent_childs/BatchInputLineItem/Batch_id/${recordId}`, {}, 'GET');
          const res = await getlineitems.makeCall();
          setBatchLineItem(res);
          setBatchInputLineAfterSave(res);
          // const getData = new ApiService(`${BASE_URL}/fetch_single_record/Batch/${recordId}`, {}, 'GET');
          // const responseData = await getData.makeCall();
          // setRecordData(responseData);
          // setSelectedBagProductForProcess(responseData?.SelectedBag?._id);
          // setSelectedFinishedProductForProcess(responseData?.FinishedProduct?._id);
          // setBagWeight(responseData?.BagWeight);
          // setExpectedPackagingQuantity(responseData?.ExpectedPackagingQuantity);
          // setBatchStartDateTime(responseData?.BatchDateTime);
          // setBatchRatioConfiguration(responseData?.RatioConfiguration);
          // setBatchNotes(responseData?.Note);
          // setBatchTotalInputQuantity(responseData?.TotalQuantity);
          // setBatchName(responseData?.Name);
          navigate(`/EnhancedCreateRecord/${objectName}/${recordId}`);
          setDisableEdit(true);
        }
      }
      catch (err) {
        const errorMessage = err && typeof err === 'object'
          ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
          : 'Failed to create due to unknown error';
        message.error(errorMessage);

      }
      finally {
        setLoading(false);
        setIsStock(false);
      }
    }

  };

  const handleCancel = () => {
    navigate(-1);
  }

  useEffect(() => {
    if (inventory.length > 0 && !savedRecord) {
      populateBatchLineItems();
    }
  }, [inventory]);

  useEffect(() => {
    if (batchLineItem?.length > 0) {
      setLoading(false);
    }
  }, [batchLineItem]);

  useEffect(() => {
    if (inventory?.length > 0 || batchLineItem?.length > 0) {
      const mergedData = inventory?.map(invItem => {
        const matchingBatchItem = Array.isArray(batchLineItem)
          ? batchLineItem.find(batchItem => batchItem?.Name === invItem?.Name)
          : undefined;
        return {
          ...invItem,
          Quantity: matchingBatchItem
            ? matchingBatchItem.UnitOfMeasure !== "Metric Tons"
              ? matchingBatchItem.RatioPercentage
                ? matchingBatchItem.UnitOfMeasure === "Bags"
                  ? Number(((((matchingBatchItem.RatioPercentage / 100) * BatchTotalInputQuantity) * 1000) / invItem?.BagWeight).toFixed(2))
                  : 0
                : 0
              : (matchingBatchItem.RatioPercentage
                ? ((matchingBatchItem.RatioPercentage / 100) * BatchTotalInputQuantity)
                : 0)
            : 0,
          TotalQuantityMetricTon: matchingBatchItem?.RatioPercentage ? Number((matchingBatchItem?.RatioPercentage / 100) * BatchTotalInputQuantity) : 0,
          RatioPercentage: matchingBatchItem ? matchingBatchItem?.RatioPercentage : 0
        };
      });

      const totalRatioPercentage = mergedData?.reduce((sum, item) => sum + (item?.RatioPercentage || 0), 0);

      if (totalRatioPercentage > 100) {
        setAlertMessage("The total ratio percentage cannot exceed 100%.");
        setInputStatusError(true);
      } else {
        setAlertMessage(""); // Clear the alert if the condition is not met
        setInputStatusError(false);

      }

      setMixedData(mergedData);
      setExpectedPackagingQuantity(parseFloat(((BatchTotalInputQuantity * 1000) / bagWeight).toFixed(4)));
    }
  }, [inventory, batchLineItem, BatchTotalInputQuantity]);

  useEffect(() => {
}, [BatchInputLineItemAfterSave]);

  useEffect(() => {
    const mergedData = inventory?.map(invItem => {
      const matchingBatchItem = Array.isArray(batchLineItem)
        ? batchLineItem.find(batchItem => batchItem?.Name === invItem?.Name)
        : undefined;
      return {
        ...invItem,
        Quantity: matchingBatchItem
          ? matchingBatchItem.UnitOfMeasure !== "Metric Tons"
            ? matchingBatchItem.RatioPercentage
              ? matchingBatchItem.UnitOfMeasure === "Bags"
                ? Number(((((matchingBatchItem.RatioPercentage / 100) * BatchTotalInputQuantity) * 1000) / invItem.BagWeight).toFixed(2))
                : 0
              : 0
            : (matchingBatchItem.RatioPercentage
              ? ((matchingBatchItem.RatioPercentage / 100) * BatchTotalInputQuantity)
              : 0)
          : 0,
        TotalQuantityMetricTon: matchingBatchItem?.RatioPercentage ? Number((matchingBatchItem?.RatioPercentage / 100) * BatchTotalInputQuantity) : 0,
        RatioPercentage: matchingBatchItem ? matchingBatchItem.RatioPercentage : 0

      };
    });


    if (Array.isArray(batchLineItem)) {
      batchLineItem.forEach(batch => {
        let matchingBatch = mergedData?.find(data => data.Name === batch.Name);
        if (matchingBatch) {
          batch.RatioPercentage = matchingBatch?.RatioPercentage;
          batch.TotalQuantityMetricTon = matchingBatch?.TotalQuantityMetricTon;
          batch.Quantity = matchingBatch?.Quantity;
        }
      });
    } else {
    }
    

    setExpectedPackagingQuantity(parseFloat(((BatchTotalInputQuantity * 1000) / bagWeight).toFixed(4)));
    setMixedData(mergedData);
  }, [BatchTotalInputQuantity])

  const extractNumericQuantity = (value) => {
    // Use regex to extract the numeric portion from a string
    const numericValue = parseFloat(value?.match(/[\d.]+/)?.[0]);
    return isNaN(numericValue) ? 0 : numericValue;
  };

  const populateBatchLineItems = (value, key) => {
   
    var x = Number(value);
    var total = Number(((value / 100) * BatchTotalInputQuantity).toFixed(2));

    setLoading(true);

    // if(recordData?.Status === "Created"){

    //   console.log('mixed data',mixedData);

    //   const finalBatchLineItems = batchLineItem?.map((item, index) => {
    //     const updatedItem = {
    //       ...item,
    //       TotalQuantityMetricTon: index === key ? total : mixedData[index]?.TotalQuantityMetricTon,
    //       Quantity: index === key
    //         ? (item?.UnitOfMeasure !== "Metric Tons"
    //           ? item?.UnitOfMeasure === "Bags" ? Number(((total * 1000) / item?.BagWeight).toFixed(2)) : total
    //           : total)
    //         : mixedData[index]?.Quantity,
    //       RatioPercentage: index === key ? x : mixedData[index]?.RatioPercentage ? mixedData[index]?.RatioPercentage : 0,
    //     };
  
    //     return updatedItem;
    //   });

    //   console.log('final batch line items', finalBatchLineItems);
      
    //   setBatchLineItem(finalBatchLineItems);
 


    // }else{

    const updatedBatchLineItems = inventory?.map((item, index) => {
      return {
        Name: item?.Name,
        TotalQuantityMetricTon: total ? total : 0,
        Quantity: index === key
          ? item.UnitOfMeasure !== "Metric Tons"
            ? item?.UnitOfMeasure === "Bags" ? Number(((total * 1000) / item?.BagWeight).toFixed(2)) : 0
            : (BatchTotalInputQuantity ? total : 0)
          : 0,
        Batch_id: recordId,
        RawMaterial_id: item?._id,
        UnitOfMeasure: item?.UnitOfMeasure,
        BagWeight: item?.BagWeight
      };
    });



    const finalBatchLineItems = updatedBatchLineItems?.map((item, index) => {
      const matchingBatchItem = batchLineItem?.find(batchItem => batchItem?.Name === item?.Name);
      const { _id, ...restOfItem } = item;
      const updatedItem = {
        ...restOfItem,
        TotalQuantityMetricTon: index === key ? total : mixedData[index]?.TotalQuantityMetricTon,
        Quantity: index === key
          ? (item?.UnitOfMeasure !== "Metric Tons"
            ? item?.UnitOfMeasure === "Bags" ? Number(((total * 1000) / item?.BagWeight).toFixed(2)) : total
            : total)
          : mixedData[index]?.Quantity,
        RatioPercentage: index === key ? x : mixedData[index]?.RatioPercentage ? mixedData[index]?.RatioPercentage : 0,
        ...(recordData?.Status === "Created" && { _id: matchingBatchItem?._id  || undefined}) // add _id conditionally

      };

      return updatedItem;
    });




    setBatchLineItem(finalBatchLineItems);
  //}
  };

  useState(() => {
    setExpectedPackagingQuantity(parseFloat(((BatchTotalInputQuantity * 1000) / bagWeight).toFixed(4)));
  }, [BatchTotalInputQuantity, bagWeight]);

  const preventScroll = (event) => {
    event?.preventDefault();
  };

  const handleTemplate = () => {
    fetchTemplates();
    setTemplateModal(true);
  }

  const templateColumns = [

    {
      title: "Product Name",
      key: "name",
      dataIndex: "name",
    },
    {
      title: "% in Mixture",
      key: "ratio_percentage",
      dataIndex: "ratio_percentage",
    }

  ];

  const onCancelModal = () => {
    setSelectedTemplate(null);
    setTemplateData(null);
    setTemplateModal(false)
  }

  const handleSelectTemplate = () => {
    mixedData.forEach(mixedItem => {
      let templateItem = templateData?.find(template => template?.id === mixedItem?._id);
      if (templateItem) {
        mixedItem.Name = templateItem?.name;
        mixedItem.RatioPercentage = Number(templateItem?.ratio_percentage);
        mixedItem.TotalQuantityMetricTon = Number(((templateItem?.ratio_percentage) / 100) * selectedTemplateBeforeSave?.input_quantity)
      }
    });

    batchLineItem.forEach(batch => {
      let matchingBatch = mixedData?.find(data => data.Name === batch.Name);
      if (matchingBatch) {
        batch.RatioPercentage = matchingBatch?.RatioPercentage;
        batch.TotalQuantityMetricTon = matchingBatch?.TotalQuantityMetricTon;
        batch.Quantity = matchingBatch?.Quantity
      }
    });

    setpieData(batchLineItem
      ?.filter(item => item.TotalQuantityMetricTon > 0)
      ?.map(item => ({ id: item.Name, label: item.Name, value: item.RatioPercentage }))
    );

    setBatchTotalInputQuantity(selectedTemplateBeforeSave?.input_quantity)

    setTemplateModal(false);

  }

  const saveTemplate = async (values) => {
    const totalRatioPercentage = Array.isArray(batchLineItem)
      ? batchLineItem.reduce((sum, item) => sum + (item?.RatioPercentage || 0), 0)
      : 0;
    if (totalRatioPercentage != 100) {
      setAlertMessage("The total ratio percentage must be exactly 100%.")
      return;
    }
    if (!BatchTotalInputQuantity) {
      message.error("Please provide total input quantity");
    }
    const formattedData = mixedData.map(mixed => ({
      name: mixed.Name,
      id: mixed._id,
      ratio_percentage: mixed.RatioPercentage
    }));

    const body = {
      mt_mixture_template: {
        Name: values.Name,
        input_quantity: BatchTotalInputQuantity,
        product_data: formattedData
      }
    }

    try {
      const apiService = new ApiService(`${BASE_URL}/create_mixture_template`, {}, 'POST', body);
      const res = await apiService.makeCall();
      form.resetFields();
      setSaveTemplateModal(false);
      fetchTemplates();
      message.success('Template Created Successfully');
    }
    catch (err) {
      const errorMessage = err && typeof err === 'object'
        ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to create due to unknown error';
      message.error(errorMessage);

    }
  }

  const handleSaveModal = () => {
    const formattedData = mixedData.map(mixed => ({
      name: mixed.Name,
      id: mixed._id,
      ratio_percentage: mixed.RatioPercentage
    }));

    setDataforTemplate(formattedData);

    setSaveTemplateModal(true)

  }

  const cancelSaveTemplate = () => {
    form.resetFields();
    setSaveTemplateModal(false);
  }

  useEffect(() => {
    const fetchSingleTemplate = async () => {
      if (selectedTemplate) {
        try {
          const apiService = new ApiService(`${BASE_URL}/get_mixture_template/${selectedTemplate}`, {}, 'GET');
          const res = await apiService.makeCall();
          setSelectedTemplateBeforeSave(res);
          setTemplateData(res?.product_data);
        }
        catch (error) {

        }
      }
    }

    fetchSingleTemplate();

  }, [selectedTemplate]);

  const restrictedTabs = ["Summary", "Processing", "Packages", "Dispatching", "Batch Activity log"];


  return (
    <div >
      <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
        <Col >
          <Title level={3} style={{ marginTop: '10px' }}>Batch life cycle</Title>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={4}>
          <Tabs activeKey={activeTab}
            onChange={(key) => {
              if (!restrictedTabs.includes(key) || recordData?._id) {
                setActiveTab(key); // Allow if not restricted OR if _id exists
              }
            }}
            tabPosition="left">
            <TabPane tab="Summary" key="Summary" />
            <TabPane tab="Batch Details" key="Batch Details" />
            <TabPane tab="Processing" key="Processing" />
            <TabPane tab="Packages" key="Packages" />
            {/* <TabPane tab="Dispatching" key="Dispatching" /> */}
            <TabPane tab="Batch Activity log" key="Batch Activity log" />
          </Tabs>
        </Col>
        <Col span={20}>
          {activeTab === "Batch Details" && (
            <Spin spinning={loading} size="medium">
              <Card title="Raw Material Mixture" >
                <Row gutter={16}>
                  <Col span={18}>
                    <div style={{ padding: '8px', borderRadius: '8px' }}>
                      <h2 style={{ marginBottom: '16px' }}>Batch Details</h2>
                      <Row gutter={16} style={{ marginBottom: '16px' }}>
                        <Col span={6}>
                          <Input
                            disabled={true}
                            addonBefore="Name"
                            style={{ width: '100%' }}
                            value={batchName}
                          />
                        </Col>

                        <Col span={10}>
                          <InputNumber
                            disabled={savedRecord && recordData?.Status !== "Created"}
                            addonBefore="Total Quantity of mixture"
                            style={{ width: '100%' }}
                            value={BatchTotalInputQuantity}
                            required={true}
                            onChange={(e) => setBatchTotalInputQuantity(e)}
                            onWheel={preventScroll}
                            addonAfter={"mt"}
                          />
                        </Col>

                        <Col span={8}>
                          {!savedRecord && (
                            <Space>
                              <DatePicker
                                disabled={savedRecord}
                                addonBefore="Batch Date and Time"
                                showTime
                                style={{ width: '100%' }}
                                placeholder="Select Batch Date and Time"
                                value={BatchStartDateTime ? dayjs(BatchStartDateTime, "DD/MM/YYYY hh:mm A") : dayjs()}
                                format="DD/MM/YYYY hh:mm A"
                                onChange={(date, dateString) => {
                                  setBatchStartDateTime(dateString);
                                }}
                                required={true}
                              />
                            </Space>
                          )}
                          {savedRecord && (
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              <Input
                                addonBefore={"Start Date"}
                                value={BatchStartDateTime ? dayjs(BatchStartDateTime).utc().format('DD/MM/YYYY hh:mm A') : ''}
                                disabled
                              />
                            </div>
                          )}
                        </Col>


                      </Row>


                      <Row style={{ marginBottom: '16px' }}>
                        <Col span={24}>
                          <Input.TextArea
                            disabled={savedRecord && recordData?.Status !== "Created"}
                            rows={3}
                            value={BatchRatioConfiguration}
                            onChange={(e) => setBatchRatioConfiguration(e.target.value)}
                            placeholder="Enter Ratio Configuration" />
                        </Col>
                      </Row>

                      <Row>
                        <Col span={24}>
                          <Input.TextArea
                            rows={3}
                            disabled={savedRecord && recordData?.Status !== "Created"}
                            value={BatchNotes}
                            onChange={(e) => setBatchNotes(e.target.value)}
                            placeholder="Add notes" />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col span={6} style={{ padding: 'auto', margin: 'auto' }}>
                    {pieData?.length > 0 && (
                      <div style={{ height: "300px", marginBottom: "20px" }}>
                        <ResponsivePie
                          data={pieData}
                          margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                          innerRadius={0.5}
                          padAngle={0.7}
                          cornerRadius={3}
                          colors={{ scheme: 'category10' }}
                          borderWidth={1}
                          borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                          radialLabelsSkipAngle={10}
                          radialLabelsTextXOffset={6}
                          radialLabelsTextColor="#333333"
                          radialLabelsLinkColor={{ from: 'color' }}
                          sliceLabelsSkipAngle={10}
                          sliceLabelsTextColor="#FFFFFF"
                        />
                      </div>
                    )}
                  </Col>
                </Row>
                <Card title="Default Packaging Information">
                  <Row gutter={24} style={{ marginBottom: '10px' }}>
                    <Col span={12}>
                      <div>
                        <Typography.Text style={{ marginBottom: '5px' }} strong>Select Finished Product</Typography.Text>
                        <Select
                          disabled={savedRecord && recordData?.Status !== "Created"}
                          showSearch
                          allowClear
                          placeholder="Select Product"
                          onChange={(e) => {
                            setSelectedFinishedProductForProcess(e)
                          }}
                          style={{ width: '100%', marginTop: '5px' }}
                          value={selectedFinishedProductForProcess}
                        >
                          {allFinishedProducts.map((product) => (
                            <Option key={product._id} value={product._id}>
                              {product.Name}
                            </Option>
                          ))}
                        </Select>
                      </div>

                    </Col>
                    <Col span={12}>
                      <div>
                        <Typography.Text style={{ marginBottom: '5px' }} strong>Select Packaging Product</Typography.Text>
                        <Select
                          disabled={savedRecord && recordData?.Status !== "Created"}
                          showSearch
                          allowClear
                          placeholder="Select Packaging Product"
                          onChange={(e) => setSelectedBagProductForProcess(e)}
                          style={{ width: '100%', marginTop: '5px' }}
                          value={selectedBagProductForProcess}
                        >
                          {allBagProducts.map((product) => (
                            <Option key={product._id} value={product._id}>
                              {product.Name}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </Col>
                  </Row>

                  <Row gutter={24} style={{ marginBottom: '10px' }}>
                    <Col span={12}>
                      <div>
                        <Typography.Text style={{ marginBottom: '5px' }} strong>Bag/Bucket Weight (kg)</Typography.Text>
                        <InputNumber
                          disabled={savedRecord && recordData?.Status !== "Created"}
                          value={bagWeight}
                          style={{ width: '100%', marginBottom: '10px', marginTop: '5px' }}
                          onChange={(e) => {
                            if (!BatchTotalInputQuantity) {
                              message.error('Please give value for total quantity');
                              return;
                            }
                            setBagWeight(e)
                            setExpectedPackagingQuantity(parseFloat(((BatchTotalInputQuantity * 1000) / e).toFixed(4)));
                          }

                          }
                        />
                      </div>
                    </Col>
                    <Col span={12}>
                      <div>
                        <Typography.Text style={{ marginBottom: '5px' }} strong>Expected Packaging Quantity</Typography.Text>
                        <Input
                          disabled={true}
                          value={ExpectedPackagingQuantity ? ExpectedPackagingQuantity : 0}
                          style={{ width: '100%', marginBottom: '10px', marginTop: '5px' }}
                        />
                      </div>
                    </Col>
                  </Row>
                </Card>
                <Card style={{ marginBottom: "20px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3>Material Selection & Mixture</h3>
                    <div>
                      <Button type="primary" onClick={handleTemplate} style={{ marginBottom: "10px" }}>
                        Use template
                      </Button>
                      <Button type="primary" onClick={handleSaveModal} style={{ marginBottom: "10px", marginLeft: '10px' }}>
                        Save as template
                      </Button>
                    </div>
                  </div>
                  <Card title="Inventory" style={{ width: "100%" }}>
                    <Table dataSource={mixedData} columns={mixedColumns} />
                  </Card>
                </Card>
                {(!(savedRecord) || recordData?.Status === "Created") && (
                  <Affix offsetBottom={50}>
                    <div style={{
                      width: '90%',
                      padding: '10px 0',
                      background: 'rgba(240, 242, 245, 0.9)', // Slightly transparent background
                      position: 'fixed',
                      bottom: '10px',
                      left: 110
                    }}>
                      <Row justify="center">
                        <Button onClick={handleCancel} style={{ marginRight: 8 }}>
                          Cancel
                        </Button>
                        <Button type="primary" onClick={handleSave}>
                          Save
                        </Button>
                      </Row>
                    </div>
                  </Affix>
                )}
              </Card>
            </Spin>
          )}
          {activeTab === "Summary" && (
            <SummaryTab
              recordData={recordData}
              inventory={inventory}
              batchLineItem={batchLineItem}
              pieData={pieData}
              allFinishedProducts={allFinishedProducts}
              selectedFinishedProductForProcess={selectedFinishedProductForProcess}
              setSelectedFinishedProductForProcess={setSelectedFinishedProductForProcess}
              selectedBagProductForProcess={selectedBagProductForProcess}
              setSelectedBagProductForProcess={setSelectedBagProductForProcess}
              allBagProducts={allBagProducts}
              bagWeight={bagWeight}
              setRecordData={setRecordData}
              extractNumericQuantity={extractNumericQuantity}
            />
          )}
          {activeTab === "Processing" && (

            <ProcessingBatch
              recordData={recordData}
            >

            </ProcessingBatch>
          )}
          {activeTab === "Packages" && (
            <PackageBatch
              recordData={recordData}
            >
            </PackageBatch>
          )}
        </Col>
      </Row>
      {alertMessage && (
        <div
          style={{
            position: "fixed",
            top: "10px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "350px",
            height: "60px",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Alert message={alertMessage} type="error" showIcon />
        </div>
      )}

      {templateModal && (
        <Modal
          title="Select template"
          visible={templateModal}
          onCancel={onCancelModal}
          footer={null}
          zIndex={1002}   // higher than sidebar
        >
          <Select
            placeholder="Select a template"
            style={{ width: "100%", marginBottom: 16 }}
            onChange={(e) => setSelectedTemplate(e)}
            value={selectedTemplate}
          >
            {(Array.isArray(allTemplates) ? allTemplates : []).map((template) => (
              <Option key={template._id} value={template._id}>
                {template.Name}
              </Option>
            ))}
          </Select>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: "bold", marginBottom: 4, display: "block" }}>
              Total Quantity:
            </label>
            <Input addonAfter="mt" value={selectedTemplateBeforeSave?.input_quantity} disabled />
          </div>

          {selectedTemplate && (
            <Table columns={templateColumns} dataSource={templateData} pagination={false} />
          )}

          <div style={{ marginTop: 16, textAlign: "right" }}>
            <Button onClick={onCancelModal} style={{ marginRight: 8 }}>Cancel</Button>
            <Button type="primary" onClick={handleSelectTemplate}>Select</Button>
          </div>
        </Modal>
      )}

      {saveTemplateModal && (
        <Modal
          title="Save template"
          visible={saveTemplateModal}
          onCancel={cancelSaveTemplate}
          footer={null}
        >
          <Form form={form} layout="vertical" onFinish={saveTemplate}>
            <Form.Item
              label="Name"
              name="Name"
              rules={[{ required: true, message: "Please enter the name" }]}
            >
              <Input placeholder="Enter template name" />
            </Form.Item>

            <Form.Item
              label="Total Quantity"
              name="totalQuantity"
            >
              <Input defaultValue={BatchTotalInputQuantity} value={BatchTotalInputQuantity} disabled={true} placeholder="Enter total quantity" />
            </Form.Item>

            <Table columns={templateColumns} dataSource={dataForTemplate} pagination={false} style={{ marginBottom: '10px' }} />


            <Form.Item style={{ display: 'flex', justifyContent: 'center' }}>
              <Space>
                <Button type="primary" htmlType="submit" >
                  Save
                </Button>
                <Button type="default" onClick={cancelSaveTemplate}>
                  Cancel
                </Button>
              </Space>
            </Form.Item>
          </Form>

        </Modal>
      )}
    </div>
  );
};

export default EnhancedCreateRecord;